import { Routes } from '@angular/router';
import {
	GuestAuthGuard,
	RedirectIfGuestAuthenticatedGuard,
} from '@context/frontend/user';

export const appRoutes: Routes = [
	{
		path: 'auth',
		canActivate: [RedirectIfGuestAuthenticatedGuard],
		data: {
			companionTitle: 'Chemicals',
			companionSuccessRoute: '/home',
			companionLogoUrl: 'assets/images/logo-white.png',
		},
		loadChildren: () =>
			import('@context/frontend/companion').then(
				(m) => m.companionAuthRoutes,
			),
	},
	{
		path: 'home',
		canActivate: [GuestAuthGuard],
		loadChildren: () => import('./pages/home/home.routes'),
	},
	{
		path: '**',
		redirectTo: 'home',
	},
];
